<template>
  <div>
    <div v-if="!status" class="flex flex-col gap-8">

    </div>

    <div v-if="status == SENT">
    <div
      class="[&_h2]:text-t4 [&_p]:text-b1 [&_h2]:mb-1"
      v-html="instructions.errorreport_create_sent_html"
    ></div>
      <div class="text-b2 mt-6 rounded-[15px] bg-primary-10 p-4" v-html="instructions.errorreport_create_sent_extra_html">
      </div>
      <div class="flex mt-4">
        <Button size="large" type="primary" :to="{ path: '/felanmalan' }" class="w-fit">
          Till felanmälan
        </Button>
      </div>
    </div>

    <div v-else-if="status == FAILED || status == INVALID_ROWS">
      <div
        class="[&_h2]:text-t4 [&_p]:text-b1 [&_h2]:mb-1"
        v-html="instructions.errorreport_create_sent_error_html"
      ></div>

      <div class="flex justify-center">
        <Button class="mt-4" size="large" @click="submitErrorReport" :disabled="disable" :loading="isLoading" loadingText="Skickar">Försök igen</Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/button';
import { dataLayerPush } from '@/helpers/datalayer';
import IconArrowRight from '@/components/icons/IconArrowRight';

const STATUSES = {
  FAILED: 1,
  INVALID_ROWS: 2,
  SENT: 3,
};
export default {
  components: { Button, IconArrowRight },
  props: ['status'],
  data() {
    return {
      isLoading: false,
      disable: false,
      ...STATUSES,
    };
  },

  computed: {
    instructions() {
      return this.$store.getters.webapp_config.msg;
    },
    rows() {
      return this.$store.getters.getErrorReportRows;
    },
    draft() {
      return this.$store.getters.getErrorReportDraft;
    },
  },

  beforeRouteLeave(to, from, next) {
    // Undviker att man kan backa från "skickat"
    if (
      Object.keys(from.query).includes('skickat') &&
      (to.name === 'ErrorReportConfirm' || to.name === 'ErrorReportAddNewRowOrFinish')
    ) {
      next(false)
      return
    }
    next()
  },

  beforeRouteUpdate(to, from, next) {
    // Undviker att man kan backa från "skickat"
    if (
      Object.keys(from.query).indexOf('skickat') > -1 &&
      (to.name == 'ErrorReportConfirm' || to.name == 'ErrorReportAddNewRowOrFinish')
    )
      return next(false);
    next();
  },
  methods: {

    async submitErrorReport() {
      if (this.disable) return;

      try {
        this.isLoading = true;
        this.disable = true;

        await this.$store.dispatch('submitErrorReportDraft');

        this.status = 3;
      } catch (err) {
        console.log("err", err)
        //this.failed = err.response.data;
        this.status = 1;
        this.disable = false;
        return Promise.reject(err);
      } finally {
        //this.$emit('update:modelValue', this.status);
        this.$emit('update:modelValue', this.status);
        this.isLoading = false;
        this.disable = false;
      }
    }
  },

  created() {
    if (this.$store.getters.getErrorReportRows.length == 0) {
      return this.$router.replace({ name: 'ErrorReportAddNew' });
    } else {
     /* if (
        this.$store.getters.getErrorReportRows.some((r) => {
          return !r.areaCode || !r.locationCode || !r.partCode || !r.description;
        })
      ) {
        this.status = STATUS.INVALID_ROWS;
      }*/
    }
  },
};
</script>
